import { feelLight } from '@bpmn-io/cm-theme';

import { baseTheme } from './theme.js';

export default [ baseTheme, feelLight ];